// extracted by mini-css-extract-plugin
export default {"rangeSlider":"index_rangeSlider__3KU3M","inputSpacer":"index_inputSpacer__j4tsW"};